import { requestIdleCallback } from '@theme/utilities';

const PARAM_NAME = 'filter.v.option.model';
const DATA_ELEMENT_ID = 'ModelCollectionFilterData';

/**
 * Applies the collection's default model filter by driving the existing facets form exactly
 * as a real filter click would (same URL update + Section Rendering re-fetch), unless the
 * visitor already has an explicit filter in the URL or no matching, enabled facet checkbox
 * exists on the page (e.g. zero products for that model) -- never fabricates a filter that
 * isn't real.
 */
async function applyDefaultModelFilter() {
  const dataElement = document.getElementById(DATA_ELEMENT_ID);
  if (!dataElement?.textContent) return;

  /** @type {string} */
  let modelValue;
  try {
    modelValue = JSON.parse(dataElement.textContent);
  } catch {
    return;
  }
  if (!modelValue) return;

  const url = new URL(window.location.href);
  if (url.searchParams.has(PARAM_NAME)) return;

  // facets.js is always loaded on collection pages, but may not have upgraded the custom
  // element yet since it's a low fetchpriority module.
  await customElements.whenDefined('facets-form-component').catch(() => {});

  const facetsForm = document.querySelector('facets-form-component');
  if (!facetsForm || typeof (/** @type {any} */ (facetsForm).updateFiltersByURL) !== 'function') return;

  const checkbox = Array.from(document.querySelectorAll(`input[type="checkbox"][name="${PARAM_NAME}"]`)).find(
    (input) => input instanceof HTMLInputElement && input.value === modelValue
  );

  if (!(checkbox instanceof HTMLInputElement) || checkbox.checked || checkbox.disabled) return;

  url.searchParams.set(PARAM_NAME, modelValue);
  /** @type {any} */ (facetsForm).updateFiltersByURL(url.toString());
}

// pageshow (not DOMContentLoaded) also fires on bfcache back/forward restores, where the grid
// should still reflect the model filter.
window.addEventListener('pageshow', () => {
  requestIdleCallback(applyDefaultModelFilter);
});
